import { Container } from './styles';

type LoaderProps = React.HTMLAttributes<HTMLDivElement> & {
  size?: number;
};

export default function Loader({ size = 24, ...rest }: LoaderProps) {
  return <Container className={rest.className} $size={size} />;
}
